import { orderBy, get, has } from 'lodash';
import moment from 'moment';
import { formatAmount } from '../../helpers/fieldHelpers';
import { frequencyKeyValues } from './constants';

export const getDateText = (refDate) => {
	const REFERENCE = moment();
	const TODAY = REFERENCE.clone().startOf('day');
	const TOMORROW = REFERENCE.clone().add(1, 'days').startOf('day');
	const date = moment(refDate, 'DD/MM/YYYY');
	let formattedDate = date.format('Do MMMM YYYY');
	const isToday = (momentDate) => momentDate.isSame(TODAY, 'd');
	const isTomorrow = (momentDate) => momentDate.isSame(TOMORROW, 'd');

	if (isToday(date)) {
		formattedDate += ' (Today)';
	} else if (isTomorrow(date)) {
		formattedDate += ' (Tomorrow)';
	}

	return formattedDate;
};

const reviewFieldMethods = (reviewData) => ({
	getValueForField(field) {
		const { srcFunction, source, isDate, isAmount } = field;
		const val = get(reviewData, source);
		if (srcFunction) return this[srcFunction](source);
		else if (isDate) return getDateText(val);
		else if (isAmount) return `£${formatAmount(val)}`;
		return val;
	},
	getPaymentType(src) {
		const {
			content: { oneOffPayment: oneOffTitle, repeatingPayment: repeatingTitle },
		} = reviewData;
		return get(reviewData, src) ? oneOffTitle : repeatingTitle;
	},
	getFrequencyName(src) {
		return frequencyKeyValues[get(reviewData, src)];
	},
	getTimesValue(src) {
		const data = get(reviewData, src);
		return data.stopWhen === '2' ? data.endValue : '';
	},
	getEndDate(src) {
		const data = get(reviewData, src);
		const { stopWhen, endValue } = data;
		if (stopWhen === '1') return 'When I cancel it';
		else if (stopWhen === '3') return endValue;
		return '';
	},
	getRemainingBalance(src) {
		const amount = get(reviewData, 'repeatData.amount');
		const currentBalance = get(reviewData, src);
		return `£${formatAmount(parseFloat((currentBalance - parseFloat(amount)).toString()).toFixed(2))}`;
	},
});

export const createEWPaymentDetails = (data) => {
	const {
		content,
		effectiveWarning: { reviewData },
	} = data;

	const reviewMethods = reviewFieldMethods(reviewData);
	const details = content.reviewFields
		.map((field) => ({ ...field, value: reviewMethods.getValueForField(field) }))
		.filter((detail) => {
			const {
				repeatData: { oneOffPayment },
			} = reviewData;
			const includePaymentType = oneOffPayment ? detail.isOneOff : detail.isRepeating;
			return detail.value && includePaymentType;
		})
		.map(({ key, value }) => ({ key, value }));

	return orderBy(details, ['orderId']);
};

export const getAmountType = (account, balanceType) => {
	const balances = account.balances || [];

	const overdraft = balances.find((bal) => bal.type === balanceType);
	const hasAmountObject = has(overdraft, 'amount.value');

	if (hasAmountObject) {
		return overdraft.amount.value;
	}
	return overdraft ? overdraft.amount : null;
};
